import React, { useState, useCallback } from "react";
import { BsChevronLeft, BsChevronRight, BsPinMapFill } from "react-icons/bs";
import hotelplace from "../../assets/hotelplace.webp";
import { getHotelImages, getHotelImage } from "../../assets/hotelImages";

const HotelCardCarousel = ({ hotelName, apiImage, location, badgePosition = "right" }) => {
  const [current, setCurrent] = useState(0);

  const localImages = getHotelImages(hotelName) || [];
  const fallback = getHotelImage(hotelName) || hotelplace;
  const allImages =
    localImages.length > 0
      ? [apiImage, ...localImages.filter((img) => img !== apiImage)]
      : [apiImage || fallback];
  const images = allImages.slice(0, 8);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  }, [images.length]);

  const next = useCallback(() => {
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  }, [images.length]);

  return (
    <div className="hotels__card-carousel">
      {images.map((img, i) => (
        <img
          key={i}
          src={img}
          loading="lazy"
          alt={hotelName}
          className={`hotels__card-slide ${i === current ? "active" : ""}`}
          onError={(e) => {
            if (e.target.src !== fallback) e.target.src = fallback;
          }}
        />
      ))}
      {images.length > 1 && (
        <>
          <button className="hotels__card-prev" onClick={prev} aria-label="Previous">
            <BsChevronLeft />
          </button>
          <button className="hotels__card-next" onClick={next} aria-label="Next">
            <BsChevronRight />
          </button>
          <span className={`hotels__card-location-badge ${badgePosition === "left" ? "hotels__card-location-badge--left" : ""}`}>
            <BsPinMapFill />
            {location}
          </span>
          <div className="hotels__card-dots">
            {images.map((_, i) => (
              <span
                key={i}
                className={`hotels__card-dot ${i === current ? "active" : ""}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default HotelCardCarousel;
